import { IconButton, Typography } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search'
import { VisibilityOutlined } from "@mui/icons-material"
import { Color } from "../../../../../../utils/theme/types/color"

export const getColumns = (colors: Color, handleRedirect: (params: any) => void, handleActions: (params: any) => void, t: (key: string) => string) => [
    {
      id: 'user',
      label: t('dashboard.indicators.completingQuestionnaires.user'),
      rowTdStyles: {
        width: '250px',
        minWidth: '250px',
        maxWidth: '250px',
        textAlign: 'left',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      headerCell: {
        width: '250px',
        minWidth: '250px',
        maxWidth: '250px',
      }
    },
  {
    id: 'schedules',
    label: t('dashboard.indicators.completingQuestionnaires.programing'),
    contentColumn: { justifyContent: 'center' },
    rowTdStyles: {
      maxWidth: '80px',
      textAlign: 'center',
    },
    headerCell: {
      maxWidth: '80px',
    },
    renderCell: (params: any) => (
      <Typography sx={{ fontWeight: 'bold', fontSize: '12px' }}>
        {params.row.schedules}
      </Typography>
    )
  },
  {
    id: 'notExecuted',
    label: t('dashboard.indicators.completingQuestionnaires.noExecuted'),
    contentColumn: { justifyContent: 'center' },
    rowTdStyles: {
      maxWidth: '80px',
      textAlign: 'center',
    },
    headerCell: {
      maxWidth: '80px',
    },
    renderCell: (params: any) => (
      <Typography sx={{ fontWeight: 'bold', fontSize: '12px' }}>
        {params.row.notExecuted}
      </Typography>
    )
  },
  {
    id: 'percentNotExecuted',
    label: `% ${t('dashboard.indicators.completingQuestionnaires.noExecuted')}`,
    contentColumn: { justifyContent: 'center' },
    rowTdStyles: {
      maxWidth: '80px',
      textAlign: 'center',
    },
    headerCell: {
      maxWidth: '80px',
    },
    renderCell: (params: any) => (
      <Typography sx={{ fontWeight: 'bold', fontSize: '12px' }}>
        {params.row.percentNotExecuted}
      </Typography>
    )
  },
  {
    id: 'finished',
    label: t('dashboard.indicators.completingQuestionnaires.finished'),
    contentColumn: { justifyContent: 'center' },
    rowTdStyles: {
      maxWidth: '80px',
      textAlign: 'center',
    },
    headerCell: {
      maxWidth: '80px',
    },
    renderCell: (params: any) => (
      <Typography sx={{ fontWeight: 'bold', fontSize: '12px' }}>
        {params.row.finished}
      </Typography>
    )
  },
  {
    id: 'percentFinished',
    label: `% ${t('dashboard.indicators.completingQuestionnaires.finished')}`,
    contentColumn: { justifyContent: 'center' },
    rowTdStyles: {
      maxWidth: '80px',
      textAlign: 'center',
    },
    headerCell: {
      maxWidth: '80px',
    },
    renderCell: (params: any) => {
      const value = parseFloat(params.row.percentFinished) || 0
      let backgroundColor = 'transparent'
      
      if (value >= 81) {
        backgroundColor = colors.color8
      } else if (value >= 61) {
        backgroundColor = colors.orangeMedium
      } else {
        backgroundColor = colors.color12
      }
      
      return (
        <Typography sx={{ 
          fontWeight: 'bold',
          fontSize: '10px',
          padding: '4px 8px',
          backgroundColor,
          borderRadius: '4px',
          display: 'inline-block',
          color: colors.color5
        }}>
          {params.row.percentFinished}
        </Typography>
      )
    }
  },
  {
    id: 'result',
    label: t('dashboard.indicators.completingQuestionnaires.result'),
    contentColumn: { justifyContent: 'center' },
    rowTdStyles: {
      maxWidth: '80px',
      textAlign: 'center',
    },
    headerCell: {
      maxWidth: '80px',
    },
    renderCell: (params: any) => (
      <Typography sx={{ fontWeight: 'bold', fontSize: '12px' }}>
        {params.row.result}
      </Typography>
    )
  },
  {
    id: 'redirect',
    label: t('dashboard.indicators.completingQuestionnaires.redirect'),
    contentColumn: { justifyContent: 'center' },
    rowTdStyles: {
      maxWidth: '60px',
      textAlign: 'center',
    },
    headerCell: {
      maxWidth: '60px',
    },
    renderCell: (params: any) => (
      <IconButton
        size="small"
        onClick={() => handleRedirect(params)}
        sx={{ color: colors.color10 }}
      >
        <SearchIcon />
      </IconButton>
    )
  },
  {
    id: 'actions',
    label: '',
    contentColumn: { justifyContent: 'center'},
    rowTdStyles: {
      minWidth: '23px',
      maxWidth: '40px',
      textAlign: 'center',
    },
    headerCell: {
      minWidth: '23px',
      maxWidth: '40px',
    },
    renderCell: (params: any) => (
      <IconButton
        size="small"
        onClick={() => handleActions(params)}
        sx={{ color: colors.color10 }}
      >
        <VisibilityOutlined />
      </IconButton>
    )
  }
]
